import React, { useContext, useEffect, useState } from 'react'
import ConfiguratorTabOverview from './configurator-tab-overview'
import { GlobalContext } from '../../../context/hoa-global-context'
import { fieldConfigurator } from './data'

const ConfiguratorContents = (props: any) => {
  const { view, updateView, orgName, orgId, setMessage, setSuccess, config = "hoaConfig" } = props
  const { selectedValues } = useContext<any>(GlobalContext);
  const [previousData, setPreviousData] = useState(JSON.parse(JSON.stringify(selectedValues)));
  const [currentData, setCurrentData] = useState<any>({})

  useEffect(() => {
    setPreviousData(JSON.parse(JSON.stringify(selectedValues)))
  }, [selectedValues])

  useEffect(() => {
    if (selectedValues && selectedValues[config] && selectedValues[config].fieldData && Object.keys(selectedValues[config].fieldData).length > 0) {
      const fieldData = { ...selectedValues }
      setCurrentData(fieldData)
    }
  }, [])

  return (
    <div className="main-configurator-container">
      {currentData[config] && currentData[config].fieldData && previousData[config] && previousData[config].fieldData &&
        <ConfiguratorTabOverview orgName={orgName} orgId={orgId} data={currentData} initialState={previousData[config].fieldData} view={view} updateView={updateView} setMessage={setMessage} setSuccess={setSuccess} />
      }
    </div>
  )
}

export default ConfiguratorContents
